import React, { useEffect, useRef, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { NoItemsContainer } from 'components/main.styled'
import { getImages } from 'features/images/imagesSlice'
import ImageItem from './ImageItem'
import { BsFillImageFill } from "react-icons/bs";
import { MediaFeedContainer } from '../media.styled'
import SpinnerSmall from 'components/SpinnerSmall'
import { useTranslation } from 'react-i18next'

export default function ImageFeed() {
    const { t } = useTranslation('media')

    const dispatch = useDispatch()
    const { profileChurch } = useSelector((state) => state.profileChurch)
    const { getImagesStatus, images, hasMoreImages, nextCursor, limit } = useSelector((state) => state.images)
    const containerRef = useRef(null)

    useEffect(() => {
        dispatch(getImages({
            churchId: profileChurch._id,
            limit: limit,
        }))
    }, [])

    const handleScroll = useCallback(() => {
        const el = containerRef.current
        if (!el) return
        const nearBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 150
        if (nearBottom && hasMoreImages && getImagesStatus !== 'LOADING') {
            dispatch(getImages({
                churchId: profileChurch._id,
                limit: limit,
                cursor: nextCursor,
            }))
        }
    }, [hasMoreImages, getImagesStatus, nextCursor, limit, profileChurch._id, dispatch])

    return (
        <MediaFeedContainer ref={containerRef} onScroll={handleScroll}>
            {
                images.length > 0 ?
                (
                    images.map((image, index) => (
                        <ImageItem key={image._id} image={image} index={index} />
                    ))
                )
                :
                (
                    getImagesStatus !== 'LOADING' &&
                    <NoItemsContainer>
                        <BsFillImageFill />
                        <div>{t('noImages')}</div>
                    </NoItemsContainer>
                )
            }

            {
                getImagesStatus === 'LOADING' && (
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', padding: '20px' }}>
                        <SpinnerSmall border='#797979' />
                    </div>
                )
            }
        </MediaFeedContainer>
    )
}
